<template>
  <div class="xjydsqDetail">
    <Header title="异动详情" type="1" route="/xjydsh/index"></Header>
    <div class="xjydsqDetail_main" style="height: calc(100% - 78px)">
      <div class="xsxxxgsq_main_header">
        <div class="header_title">
          <h3>
            {{ xsydxx.xm ? xsydxx.xm : "-" }}-{{ xsydxx.xh ? xsydxx.xh : "-" }}
          </h3>
        </div>
        <ul class="header_info">
          <li>
            <span>异动类别:</span>
            <p>{{ xsydxx.ydlb ? xsydxx.ydlb : "-" }}</p>
          </li>
          <li>
            <span>申请理由:</span>
            <p>{{ xsydxx.sqly ? xsydxx.sqly : "-" }}</p>
          </li>
        </ul>
      </div>
      <div class="xjydsqDetail_main_content">
        <van-collapse v-model="activeNames">
          <van-collapse-item name="1">
            <template #title>
              <div class="item_title">学生当前情况</div>
            </template>
            <mode-xsdqqk :info="xsdqqk"></mode-xsdqqk>
          </van-collapse-item>
          <van-collapse-item name="2">
            <template #title>
              <div class="item_title">异动后情况</div>
            </template>
            <mode-ydhqk :info="ydhqk"></mode-ydhqk>
          </van-collapse-item>
          <van-collapse-item title="附件" name="3">
            <mode-file :fileList="fjList" :type="'detail'"></mode-file>
          </van-collapse-item>
        </van-collapse>
      </div>
      <div class="back_top" @click="backTop">
        <van-icon name="back-top" />
      </div>
    </div>
    <div class="update-button">
      <van-button type="default" @click="cancel">取消</van-button>
      <van-button type="primary" @click="savData">审核</van-button>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
import modeXsdqqk from "./mode/modeXsdqqk.vue";
import ModeYdhqk from "./mode/modeYdhqk.vue";
import modeFile from "./mode/modeFile.vue";
export default {
  components: { modeXsdqqk, ModeYdhqk, modeFile },
  data() {
    return {
      info: {},
      xsydxx: {},
      xsdqqk: {},
      ydhqk: {},
      fjList: [],
      activeNames: ["1", "2", "3"]
    };
  },
  created() {
    this.info = this.$route.query;
    this.getListDetail();
  },
  methods: {
    cancel() {
      this.$router.replace("/xjydsh/index");
    },
    savData() {
      this.$router.push({
        path: "/xjydsh/sh",
        query: this.info
      });
    },
    backTop() {
      $(".xjydsqDetail_main")[0].scrollTop = 0;
    },
    async getListDetail() {
      this.arrList = [];
      const res = await Api.xjydDetail({ xs0702id: this.info.ywinstanceid });
      if (res.code == "1") {
        this.xsydxx = res.data.xsydxx;
        this.xsdqqk = res.data.xsdqqk;
        this.ydhqk = res.data.ydhqk;
        this.fjList = res.data.fjList;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.xjydsqDetail {
  height: 100%;
  background-color: #f2f2f4;
  overflow: auto;
  .xjydsqDetail_main {
    overflow: auto;
    .xsxxxgsq_main_header {
      background-image: linear-gradient(168deg, #ffffff 36%, #f3f2ff 100%);
      border: 1.5px solid #ffffff;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.08);
      border-radius: 0 0 10px 10px;
      padding: 14px 20px;
      .header_title {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        h3 {
          font-family: PingFangSC-Medium;
          font-size: 18px;
          color: #333333;
          letter-spacing: 0;
          font-weight: bolder;
          max-width: calc(~"100% - 43px");
        }
        .header_icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 38px;
          height: 17px;
          background: rgba(255, 71, 60, 0.15);
          border-radius: 9px;
          margin-left: 5px;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #ff473c;
          letter-spacing: 0;
          font-weight: 400;
          span {
            margin-left: 2px;
          }
        }
      }
      .header_info {
        li {
          display: flex;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #666666;
          letter-spacing: 0;
          font-weight: 400;
          span {
            white-space: nowrap;
          }
          p {
            white-space: wrap;
            margin-left: 5px;
          }
          & + li {
            margin-top: 2px;
          }
        }
      }
    }
    .xjydsqDetail_main_content {
      padding: 10px 15px 0;
      height: calc(~"100% - 78px");
      .item_title {
        position: relative;
        padding-left: 12px;
        line-height: 22px;
        &::before {
          content: "";
          position: absolute;
          height: 16px;
          border-left: 4px solid #7469f8;
          border-radius: 2px;
          left: 0;
          top: 3px;
        }
      }
      /deep/.item_main {
        & > li {
          display: flex;
          & + li {
            margin-top: 8px;
          }
          span {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #333333;
            letter-spacing: 0;
            font-weight: 400;
            white-space: nowrap;
            line-height: 20px;
          }
          p {
            white-space: wrap;
            margin-left: 5px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #666666;
            letter-spacing: 0;
            font-weight: 400;
            line-height: 20px;
          }
        }
      }
    }
    /deep/.van-collapse-item {
      background: #ffffff;
      box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      overflow: hidden;
      margin-bottom: 10px;

      .van-cell {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 400;
      }
      .van-cell__right-icon {
        color: #333333;
      }
      .van-collapse-item__title::after {
        right: 0;
        left: 0;
        border-bottom: 1px solid #e5e5e5;
      }
      .van-collapse-item__content {
        padding: 14px 15px;
      }
    }
    .back_top {
      position: fixed;
      display: flex;
      justify-content: center;
      align-items: center;
      right: 8px;
      bottom: 20%;
      width: 40px;
      height: 40px;
      background: #7469f8;
      background-color: #7469f8;
      border-radius: 50%;
      .van-icon {
        color: #fff;
        font-weight: bolder;
        font-size: 25px;
      }
    }
    /deep/.van-cell-group {
      margin-bottom: 8px;
      .van-cell {
        padding: 14px 15px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        letter-spacing: 0;
        font-weight: 400;
        &::after {
          left: 15px;
          right: 15px;
          border-bottom: 1px solid #e5e5e5;
        }
        .van-field__label {
          span {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #333333;
            letter-spacing: 0;
            font-weight: 400;
          }
        }
        .van-field__control::placeholder {
          color: #b2b2b2 !important;
        }
        .van-field__right-icon {
          .van-icon {
            color: #b2b2b2;
          }
        }
        .van-field__word-limit {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #b2b2b2;
          letter-spacing: 0.3px;
          font-weight: 400;
        }
        &.qz-textarea {
          flex-direction: column;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          letter-spacing: 0.3px;
          font-weight: 400;
          .van-field__control::placeholder {
            color: #b2b2b2 !important;
          }
        }
      }
    }
  }
  .update-button {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    left: 0;
    bottom: 0;
    height: 70px;
    background: #ffffff;
    padding: 10px 15px;
    border-top: 1px solid #e5e5e5;
    .van-button {
      height: 100%;
      width: calc(~"50% - 7.5px");
      border: 1px solid #e5e5e5;
      border-radius: 25px !important;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      letter-spacing: 0;
      text-align: center;
      font-weight: 500;
    }
    .van-button--normal {
      color: #666666;
    }
    .van-button--primary {
      color: #ffffff;
      background-color: #7469f8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/xjydsh/detail.vue